import React, { useState, useContext, useEffect } from "react";
import MainContainer from "../../components/MainContainer";
import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import ForbiddenPage from "../../components/ForbiddenPage";
import usePlans from "../../hooks/usePlans";
import { toast } from "react-toastify";
import { 
  Edit as EditIcon, 
  Delete as DeleteIcon, 
  Save as SaveIcon, 
  Close as CloseIcon, 
  Add as AddIcon,
  Visibility as VisibilityIcon
} from "@material-ui/icons";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import ConfirmationModal from "../../components/ConfirmationModal";

const useStyles = () => ({
  container: {
    padding: "24px",
    background: "#f5f7fa",
    minHeight: "100vh",
  },
  header: {
    marginBottom: "24px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "16px",
  },
  title: {
    fontSize: "28px",
    fontWeight: 700,
    color: "#1a1a1a",
    margin: 0,
  },
  formCard: {
    background: "white",
    borderRadius: "12px",
    padding: "24px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
    border: "1px solid #e8ecf1",
    marginBottom: "24px",
  },
  formGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "16px",
    marginBottom: "16px",
  },
  formGroup: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    fontSize: "12px",
    fontWeight: 600,
    color: "#666",
    marginBottom: "6px",
    display: "block",
  },
  input: {
    padding: "10px 12px",
    border: "1px solid #e8ecf1",
    borderRadius: "6px",
    fontSize: "13px",
    fontFamily: "inherit",
    background: "#fafbfc",
    transition: "all 0.2s ease",
  },
  select: {
    padding: "10px 12px",
    border: "1px solid #e8ecf1",
    borderRadius: "6px",
    fontSize: "13px",
    fontFamily: "inherit",
    background: "#fafbfc",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  formActions: {
    display: "flex",
    gap: "12px",
    justifyContent: "flex-end",
    paddingTop: "16px",
    borderTop: "1px solid #e8ecf1",
    flexWrap: "wrap",
  },
  button: {
    padding: "10px 20px",
    background: "#3b82f6",
    color: "white",
    border: "none",
    borderRadius: "6px",
    fontSize: "13px",
    fontWeight: 600,
    cursor: "pointer",
    transition: "all 0.3s ease",
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  buttonSecondary: {
    padding: "10px 20px",
    background: "#e8ecf1",
    color: "#1a1a1a",
    border: "none",
    borderRadius: "6px",
    fontSize: "13px",
    fontWeight: 600,
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
  buttonDanger: {
    padding: "10px 20px",
    background: "#ef4444",
    color: "white",
    border: "none",
    borderRadius: "6px",
    fontSize: "13px",
    fontWeight: 600,
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
  tableCard: {
    background: "white",
    borderRadius: "12px",
    padding: "20px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
    border: "1px solid #e8ecf1",
    overflow: "hidden",
  },
  tableContainer: {
    overflowX: "auto",
    maxHeight: "calc(100vh - 300px)",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  tableHeader: {
    background: "#f9fafb",
    borderBottom: "2px solid #e8ecf1",
    position: "sticky",
    top: 0,
  },
  tableHeaderCell: {
    padding: "12px",
    textAlign: "center",
    fontSize: "12px",
    fontWeight: 700,
    color: "#666",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  tableRow: {
    borderBottom: "1px solid #e8ecf1",
    transition: "all 0.2s ease",
  },
  tableCell: {
    padding: "12px",
    fontSize: "13px",
    color: "#1a1a1a",
    textAlign: "center",
  },
  tableActions: {
    display: "flex",
    gap: "8px",
    justifyContent: "center",
    alignItems: "center",
  },
  iconButton: {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "4px",
    transition: "all 0.2s ease",
    color: "#3b82f6",
  },
  emptyState: {
    textAlign: "center",
    padding: "40px 20px",
    color: "#999",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalContent: {
    background: "white",
    borderRadius: "12px",
    padding: "32px",
    boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
    maxWidth: "800px",
    width: "90%",
    maxHeight: "90vh",
    overflowY: "auto",
  },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "24px",
    paddingBottom: "16px",
    borderBottom: "1px solid #e8ecf1",
  },
  modalTitle: {
    fontSize: "20px",
    fontWeight: 700,
    color: "#1a1a1a",
    margin: 0,
  },
  closeButton: {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#999",
    transition: "all 0.2s ease",
  },
  filterContainer: {
    background: "white",
    borderRadius: "12px",
    padding: "20px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
    border: "1px solid #e8ecf1",
    marginBottom: "24px",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "16px",
    alignItems: "flex-end",
  },
  filterGroup: {
    display: "flex",
    flexDirection: "column",
  },
  paginationContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 20px",
    borderTop: "1px solid #e8ecf1",
    background: "#f9fafb",
    borderBottomLeftRadius: "12px",
    borderBottomRightRadius: "12px",
  },
  paginationInfo: {
    fontSize: "13px",
    color: "#666",
  },
  paginationButtons: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
  },
  paginationButton: {
    padding: "8px 12px",
    background: "#e8ecf1",
    color: "#1a1a1a",
    border: "none",
    borderRadius: "6px",
    fontSize: "13px",
    fontWeight: 600,
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  paginationButtonActive: {
    background: "#3b82f6",
    color: "white",
  },
});

export default function Plans() {
  const styles = useStyles();
  const { user } = useContext(AuthContext);
  const { list, save, update, remove } = usePlans();

  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState([]);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [formData, setFormData] = useState({
    name: "",
    users: 0,
    connections: 0,
    queues: 0,
    amount: 0,
    useWhatsapp: true,
    useFacebook: true,
    useInstagram: true,
    useCampaigns: true,
    useSchedules: true,
    useInternalChat: true,
    useExternalApi: true,
    useKanban: true,
    useOpenAi: true,
    useIntegrations: true,
    isPublic: true,
    useWhatsappOfficial: false,
    trial: false,
    trialDays: 3,
    recurrence: "monthly",
    wavoip: false,
  });

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoading(true);
    try {
      const plansList = await list();
      setRecords(plansList);
      setCurrentPage(1);
    } catch (e) {
      toast.error("Erro ao carregar dados");
    }
    setLoading(false);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSelectRecord = (record) => {
    setFormData({
      id: record.id,
      name: record.name || "",
      users: record.users || 0,
      connections: record.connections || 0,
      queues: record.queues || 0,
      amount: record.amount || 0,
      useWhatsapp: record.useWhatsapp !== false,
      useFacebook: record.useFacebook !== false,
      useInstagram: record.useInstagram !== false,
      useCampaigns: record.useCampaigns !== false,
      useSchedules: record.useSchedules !== false,
      useInternalChat: record.useInternalChat !== false,
      useExternalApi: record.useExternalApi !== false,
      useKanban: record.useKanban !== false,
      useOpenAi: record.useOpenAi !== false,
      useIntegrations: record.useIntegrations !== false,
      isPublic: record.isPublic !== false,
      useWhatsappOfficial: record.useWhatsappOfficial === true,
      trial: record.trial === true,
      trialDays: record.trialDays || 3,
      recurrence: record.recurrence || "monthly",
      wavoip: record.wavoip === true,
    });
    setSelectedRecord(record);
    setShowModal(true);
  };

  const handleClear = () => {
    setFormData({
      name: "",
      users: 0,
      connections: 0,
      queues: 0,
      amount: 0,
      useWhatsapp: true,
      useFacebook: true,
      useInstagram: true,
      useCampaigns: true,
      useSchedules: true,
      useInternalChat: true,
      useExternalApi: true,
      useKanban: true,
      useOpenAi: true,
      useIntegrations: true,
      isPublic: true,
      useWhatsappOfficial: false,
      trial: false,
      trialDays: 3,
      recurrence: "monthly",
      wavoip: false,
    });
    setSelectedRecord(null);
    setShowModal(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (formData.id) {
        await update(formData);
      } else {
        await save(formData);
      }
      await loadData();
      handleClear();
      toast.success("Operação realizada com sucesso!");
    } catch (e) {
      toast.error("Erro ao salvar plano");
    }
    setLoading(false);
  };

  const handleDelete = async () => {
    setLoading(true);
    try {
      await remove(selectedRecord.id);
      await loadData();
      handleClear();
      setShowConfirmDialog(false);
      toast.success("Plano deletado com sucesso!");
    } catch (e) {
      toast.error("Erro ao deletar plano");
    }
    setLoading(false);
  };

  const filteredRecords = records.filter((record) =>
    record.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredRecords.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedRecords = filteredRecords.slice(startIndex, endIndex);

  if (!user.super) {
    return <ForbiddenPage />;
  }

  return (
    <MainContainer>
      <div style={styles.container}>
        <div style={styles.header}>
          <h1 style={styles.title}>💳 {i18n.t("settings.tabs.plans")}</h1>
          <button
            onClick={() => {
              handleClear();
              setShowModal(true);
            }}
            style={{
              padding: "10px",
              background: "var(--primaryColor, #065183)",
              color: "white",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              transition: "all 0.3s ease",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onMouseEnter={(e) => {
              e.target.style.opacity = "0.9";
              e.target.style.transform = "translateY(-1px)";
              e.target.style.boxShadow = "0 2px 8px rgba(6, 81, 131, 0.3)";
            }}
            onMouseLeave={(e) => {
              e.target.style.opacity = "1";
              e.target.style.transform = "none";
              e.target.style.boxShadow = "none";
            }}
            title="Adicionar Plano"
          >
            <AddIcon style={{ fontSize: "20px" }} />
          </button>
        </div>

        {/* Filtros */}
        <div style={styles.filterContainer}>
          <div style={styles.filterGroup}>
            <label style={styles.label}>Buscar</label>
            <input
              style={styles.input}
              type="text"
              placeholder="Nome do plano..."
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1);
              }}
            />
          </div>
        </div>

        {/* Tabela */}
        <div style={styles.tableCard}>
          <div style={styles.tableContainer}>
            {paginatedRecords.length === 0 ? (
              <div style={styles.emptyState}>
                <p>{records.length === 0 ? "Nenhum plano cadastrado" : "Nenhum plano encontrado"}</p>
              </div>
            ) : (
              <table style={styles.table}>
                <thead style={styles.tableHeader}>
                  <tr>
                    <th style={styles.tableHeaderCell}>{i18n.t("plans.form.name")}</th>
                    <th style={styles.tableHeaderCell}>{i18n.t("plans.form.users")}</th>
                    <th style={styles.tableHeaderCell}>{i18n.t("plans.form.public")}</th>
                    <th style={styles.tableHeaderCell}>Dias de Teste</th>
                    <th style={styles.tableHeaderCell}>{i18n.t("plans.form.connections")}</th>
                    <th style={styles.tableHeaderCell}>Filas</th>
                    <th style={styles.tableHeaderCell}>Valor</th>
                    <th style={styles.tableHeaderCell}>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedRecords.map((record) => (
                    <tr key={record.id} style={styles.tableRow}>
                      <td style={styles.tableCell}>{record.name || "-"}</td>
                      <td style={styles.tableCell}>{record.users || "-"}</td>
                      <td style={styles.tableCell}>{record.isPublic ? "Sim" : "Não"}</td>
                      <td style={styles.tableCell}>{record.trialDays || "-"}</td>
                      <td style={styles.tableCell}>{record.connections || "-"}</td>
                      <td style={styles.tableCell}>{record.queues || "-"}</td>
                      <td style={styles.tableCell}>
                        {i18n.t("plans.form.money")} {record.amount ? record.amount.toLocaleString("pt-br", { minimumFractionDigits: 2 }) : "00.00"}
                      </td>
                      <td style={styles.tableCell}>
                        <div style={styles.tableActions}>
                          <button
                            style={{
                              ...styles.iconButton,
                              color: "#10b981",
                            }}
                            onClick={() => handleSelectRecord(record)}
                            title="Visualizar"
                          >
                            <VisibilityIcon style={{ width: 18, height: 18 }} />
                          </button>
                          <button
                            style={styles.iconButton}
                            onClick={() => handleSelectRecord(record)}
                            title="Editar"
                          >
                            <EditIcon style={{ width: 18, height: 18 }} />
                          </button>
                          <button
                            style={{
                              ...styles.iconButton,
                              color: "#ef4444",
                            }}
                            onClick={() => {
                              setSelectedRecord(record);
                              setShowConfirmDialog(true);
                            }}
                            title="Deletar"
                          >
                            <DeleteIcon style={{ width: 18, height: 18 }} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
          {records.length > 0 && (
            <div style={styles.paginationContainer}>
              <div style={styles.paginationInfo}>
                Mostrando {startIndex + 1} a {Math.min(endIndex, filteredRecords.length)} de {filteredRecords.length} planos
              </div>
              <div style={styles.paginationButtons}>
                <button
                  style={{
                    ...styles.paginationButton,
                    opacity: currentPage === 1 ? 0.5 : 1,
                  }}
                  onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                  disabled={currentPage === 1}
                >
                  ← Anterior
                </button>
                {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                  <button
                    key={page}
                    style={{
                      ...styles.paginationButton,
                      ...(currentPage === page ? styles.paginationButtonActive : {}),
                    }}
                    onClick={() => setCurrentPage(page)}
                  >
                    {page}
                  </button>
                ))}
                <button
                  style={{
                    ...styles.paginationButton,
                    opacity: currentPage === totalPages ? 0.5 : 1,
                  }}
                  onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
                  disabled={currentPage === totalPages}
                >
                  Próxima →
                </button>
              </div>
            </div>
          )}
        </div>

        <ConfirmationModal
          title="Deletar Plano"
          open={showConfirmDialog}
          onClose={() => setShowConfirmDialog(false)}
          onConfirm={handleDelete}
        >
          Tem certeza que deseja deletar este plano? Esta ação não pode ser desfeita.
        </ConfirmationModal>

        {/* Modal de Edição */}
        <Modal
          style={styles.modal}
          open={showModal}
          onClose={handleClear}
          BackdropComponent={Backdrop}
          BackdropProps={{ style: { backgroundColor: "rgba(0, 0, 0, 0.5)" } }}
        >
          <div style={styles.modalContent}>
            <div style={styles.modalHeader}>
              <h2 style={styles.modalTitle}>
                {formData.id ? "Editar Plano" : "Novo Plano"}
              </h2>
              <button
                style={styles.closeButton}
                onClick={handleClear}
                type="button"
              >
                <CloseIcon style={{ width: 24, height: 24 }} />
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div style={styles.formGrid}>
                {/* Público */}
                <div style={styles.formGroup}>
                  <label style={styles.label}>{i18n.t("plans.form.public")}</label>
                  <select
                    style={styles.select}
                    name="isPublic"
                    value={formData.isPublic}
                    onChange={handleInputChange}
                  >
                    <option value={true}>Sim</option>
                    <option value={false}>Não</option>
                  </select>
                </div>

                {/* Teste */}
                <div style={styles.formGroup}>
                  <label style={styles.label}>Teste</label>
                  <select
                    style={styles.select}
                    name="trial"
                    value={formData.trial}
                    onChange={handleInputChange}
                  >
                    <option value={true}>Sim</option>
                    <option value={false}>Não</option>
                  </select>
                </div>

                {/* Dias de Teste */}
                <div style={styles.formGroup}>
                  <label style={styles.label}>Dias de Teste</label>
                  <input
                    style={styles.input}
                    type="number"
                    name="trialDays"
                    value={formData.trialDays}
                    onChange={handleInputChange}
                    disabled={!formData.trial}
                    min="1"
                  />
                </div>

                {/* Nome */}
                <div style={styles.formGroup}>
                  <label style={styles.label}>{i18n.t("plans.form.name")}</label>
                  <input
                    style={styles.input}
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Nome do plano"
                    required
                  />
                </div>

                {/* Usuários */}
                <div style={styles.formGroup}>
                  <label style={styles.label}>{i18n.t("plans.form.users")}</label>
                  <input
                    style={styles.input}
                    type="number"
                    name="users"
                    value={formData.users}
                    onChange={handleInputChange}
                  />
                </div>

                {/* Conexões */}
                <div style={styles.formGroup}>
                  <label style={styles.label}>{i18n.t("plans.form.connections")}</label>
                  <input
                    style={styles.input}
                    type="number"
                    name="connections"
                    value={formData.connections}
                    onChange={handleInputChange}
                  />
                </div>

                {/* Filas */}
                <div style={styles.formGroup}>
                  <label style={styles.label}>Filas</label>
                  <input
                    style={styles.input}
                    type="number"
                    name="queues"
                    value={formData.queues}
                    onChange={handleInputChange}
                  />
                </div>

                {/* Valor */}
                <div style={styles.formGroup}>
                  <label style={styles.label}>Valor</label>
                  <input
                    style={styles.input}
                    type="text"
                    name="amount"
                    value={formData.amount}
                    onChange={handleInputChange}
                  />
                </div>

                {/* Whatsapp */}
                <div style={styles.formGroup}>
                  <label style={styles.label}>Whatsapp</label>
                  <select
                    style={styles.select}
                    name="useWhatsapp"
                    value={formData.useWhatsapp}
                    onChange={handleInputChange}
                  >
                    <option value={true}>{i18n.t("plans.form.enabled")}</option>
                    <option value={false}>{i18n.t("plans.form.disabled")}</option>
                  </select>
                </div>

                {/* Whatsapp Oficial */}
                <div style={styles.formGroup}>
                  <label style={styles.label}>Whatsapp Oficial</label>
                  <select
                    style={styles.select}
                    name="useWhatsappOfficial"
                    value={formData.useWhatsappOfficial}
                    onChange={handleInputChange}
                  >
                    <option value={true}>{i18n.t("plans.form.enabled")}</option>
                    <option value={false}>{i18n.t("plans.form.disabled")}</option>
                  </select>
                </div>

                {/* Facebook */}
                <div style={styles.formGroup}>
                  <label style={styles.label}>Facebook</label>
                  <select
                    style={styles.select}
                    name="useFacebook"
                    value={formData.useFacebook}
                    onChange={handleInputChange}
                  >
                    <option value={true}>{i18n.t("plans.form.enabled")}</option>
                    <option value={false}>{i18n.t("plans.form.disabled")}</option>
                  </select>
                </div>

                {/* Instagram */}
                <div style={styles.formGroup}>
                  <label style={styles.label}>Instagram</label>
                  <select
                    style={styles.select}
                    name="useInstagram"
                    value={formData.useInstagram}
                    onChange={handleInputChange}
                  >
                    <option value={true}>{i18n.t("plans.form.enabled")}</option>
                    <option value={false}>{i18n.t("plans.form.disabled")}</option>
                  </select>
                </div>

                {/* Campanhas */}
                <div style={styles.formGroup}>
                  <label style={styles.label}>{i18n.t("plans.form.campaigns")}</label>
                  <select
                    style={styles.select}
                    name="useCampaigns"
                    value={formData.useCampaigns}
                    onChange={handleInputChange}
                  >
                    <option value={true}>{i18n.t("plans.form.enabled")}</option>
                    <option value={false}>{i18n.t("plans.form.disabled")}</option>
                  </select>
                </div>

                {/* Agendamentos */}
                <div style={styles.formGroup}>
                  <label style={styles.label}>{i18n.t("plans.form.schedules")}</label>
                  <select
                    style={styles.select}
                    name="useSchedules"
                    value={formData.useSchedules}
                    onChange={handleInputChange}
                  >
                    <option value={true}>{i18n.t("plans.form.enabled")}</option>
                    <option value={false}>{i18n.t("plans.form.disabled")}</option>
                  </select>
                </div>

                {/* Chat Interno */}
                <div style={styles.formGroup}>
                  <label style={styles.label}>Chat Interno</label>
                  <select
                    style={styles.select}
                    name="useInternalChat"
                    value={formData.useInternalChat}
                    onChange={handleInputChange}
                  >
                    <option value={true}>{i18n.t("plans.form.enabled")}</option>
                    <option value={false}>{i18n.t("plans.form.disabled")}</option>
                  </select>
                </div>

                {/* API Externa */}
                <div style={styles.formGroup}>
                  <label style={styles.label}>API Externa</label>
                  <select
                    style={styles.select}
                    name="useExternalApi"
                    value={formData.useExternalApi}
                    onChange={handleInputChange}
                  >
                    <option value={true}>{i18n.t("plans.form.enabled")}</option>
                    <option value={false}>{i18n.t("plans.form.disabled")}</option>
                  </select>
                </div>

                {/* Kanban */}
                <div style={styles.formGroup}>
                  <label style={styles.label}>Kanban</label>
                  <select
                    style={styles.select}
                    name="useKanban"
                    value={formData.useKanban}
                    onChange={handleInputChange}
                  >
                    <option value={true}>{i18n.t("plans.form.enabled")}</option>
                    <option value={false}>{i18n.t("plans.form.disabled")}</option>
                  </select>
                </div>

                {/* Talk.Ai */}
                <div style={styles.formGroup}>
                  <label style={styles.label}>Talk.Ai</label>
                  <select
                    style={styles.select}
                    name="useOpenAi"
                    value={formData.useOpenAi}
                    onChange={handleInputChange}
                  >
                    <option value={true}>{i18n.t("plans.form.enabled")}</option>
                    <option value={false}>{i18n.t("plans.form.disabled")}</option>
                  </select>
                </div>

                {/* Integrações */}
                <div style={styles.formGroup}>
                  <label style={styles.label}>Integrações</label>
                  <select
                    style={styles.select}
                    name="useIntegrations"
                    value={formData.useIntegrations}
                    onChange={handleInputChange}
                  >
                    <option value={true}>{i18n.t("plans.form.enabled")}</option>
                    <option value={false}>{i18n.t("plans.form.disabled")}</option>
                  </select>
                </div>

                {/* Wavoip */}
                <div style={styles.formGroup}>
                  <label style={styles.label}>Wavoip</label>
                  <select
                    style={styles.select}
                    name="wavoip"
                    value={formData.wavoip}
                    onChange={handleInputChange}
                  >
                    <option value={true}>{i18n.t("plans.form.enabled")}</option>
                    <option value={false}>{i18n.t("plans.form.disabled")}</option>
                  </select>
                </div>
              </div>

              <div style={styles.formActions}>
                <button
                  type="button"
                  style={styles.buttonSecondary}
                  onClick={handleClear}
                >
                  <CloseIcon style={{ width: 16, height: 16 }} />
                  {i18n.t("plans.form.clear")}
                </button>
                {formData.id && (
                  <button
                    type="button"
                    style={styles.buttonDanger}
                    onClick={() => {
                      setShowConfirmDialog(true);
                    }}
                    disabled={loading}
                  >
                    <DeleteIcon style={{ width: 16, height: 16 }} />
                    {i18n.t("plans.form.delete")}
                  </button>
                )}
                <button
                  type="submit"
                  style={styles.button}
                  disabled={loading}
                >
                  <SaveIcon style={{ width: 16, height: 16 }} />
                  {loading ? "Salvando..." : i18n.t("plans.form.save")}
                </button>
              </div>
            </form>
          </div>
        </Modal>
      </div>
    </MainContainer>
  );
}
